<template>
    <div class="flex-thumbnail" :class="activeClass">
        <img :src="renderImage" :alt="`${ text } thumbnail`">
        <div class="flex-thumbnail__text">{{ text }}</div>
    </div>
</template>

<script>
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    name: 'thumbnail',

    props: {
        image: {
            type: String,
            default: 'https://via.placeholder.com/150x225?text=template',
        },

        text: {
            type: String,
            default: 'Template',
        },

        isSelected: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            STATE_CLASSES,
        };
    },

    computed: {
        activeClass() {
            return {
                [STATE_CLASSES.SELECTED]: this.isSelected,
            };
        },

        renderImage() {
            return this.image ? this.image : 'https://via.placeholder.com/150x225?text=template';
        },
    },
};
</script>

<style lang="scss">

.flex-thumbnail {
    padding: 15px;
    text-align: center;

    img {
        margin: auto;
        object-fit: cover;
        width: 100%;
        object-position: 50% 50%;
        min-height: 236px;
    }

    &:hover,
    &.#{ $is-selected } {
        cursor: pointer;
        color: var(--app-backgroundColor);
        background-color: var(--app-linkHoverColor);
    }

    &__text {
        position: relative;
        top: 0.4em;
    }
}
</style>
